import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpEventType } from '@angular/common/http';
import { map, retry } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import {  Response,ResponseUSer } from 'src/app/_models';


@Injectable({ providedIn: 'root' })
export class ProfileService {
    

    constructor(private http: HttpClient) {
        
    }


    login(useremail: string, keyAccess: string) {
        localStorage.setItem('currentUser', JSON.stringify(ResponseUSer));

        return this.http.post<any>(`${environment.apiUrl}/UsersAccounts`, { useremail, keyAccess },{
            headers: new HttpHeaders(
              {
                 
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Access-Control-Allow-Origin",
                "Access-Control-Allow-Methods":"PUT, GET, POST, DELETE, OPTIONS",
                "withCredentials":"true"
              })
          }).pipe(map(ResponseUSer => {

            return ResponseUSer;
            }));
    }

  
}